export default __webpack_public_path__ + "static/media/010-poodle.6fcc553a.svg";